import { render, staticRenderFns } from "./pointsDeduct.vue?vue&type=template&id=1e66d9d8"
import script from "./pointsDeduct.vue?vue&type=script&lang=js"
export * from "./pointsDeduct.vue?vue&type=script&lang=js"
import style0 from "./pointsDeduct.vue?vue&type=style&index=0&id=1e66d9d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports